import { selectRawProductsArray } from './selectors';
const EMPTY_ARRAY = [];
export const selectFrDomainCreateForBundle = (state, id) => selectRawProductsArray(state).find(({
  payload,
  productType,
  process,
  bundleId
}) => productType === 'domain' && process === 'create' && payload.tld === 'fr' && bundleId === id);
export const selectSHSCreateForBundle = (state, id) => selectRawProductsArray(state).find(({
  productType,
  process,
  bundleId
}) => productType === 'paas' && process === 'create' && bundleId === id);
export const selectRawBundles = state => state.cart.bundles || EMPTY_ARRAY;
export const selectRawBundleById = (state, bundleId) => selectRawBundles(state).find(({
  id
}) => id === bundleId);
export const selectHasBundleByType = (state, type) => selectRawBundles(state).some(bundle => type === bundle.type);
export const selectEveryBundleByType = (state, type) => selectRawBundles(state).filter(bundle => type === bundle.type);
export const selectUncompletedBundleByType = (state, type) => selectRawBundles(state).find(bundle => type === bundle.type && bundle.is_partial_type && !bundle.is_complete);
export const selectHasDomainCreateByFqdnAndBundleType = (state, args) => {
  const {
    type,
    fqdn
  } = args;
  const bundleIds = selectRawBundles(state).filter(bundle => bundle.type === type).map(bundle => bundle.id);
  if (bundleIds.length === 0) {
    return false;
  }
  return selectRawProductsArray(state).some(product => product.productType === 'domain' && product.process === 'create' && product.payload.fqdn === fqdn && bundleIds.includes(product.bundleId));
};